export default __webpack_public_path__ + "img/eNFAWAak.b8023587.svg";